export enum TenantConfigTypes {
  InvoiceGenerator = 'invoiceGenerator',
  Otp = 'otp',
  OnboardingModules = 'OnBoardedModules',
  Theme = 'theme'
}
